export default __webpack_public_path__ + "static/media/necromancer_color.4ff15214.png";